enum GuideType {
  WEB = "web",
  MOBILE = "mobile",
}

export default GuideType;
